<template>
  <div class="content-v2">
    <BreadcrumbV2 :items="breadcrumbItems" />
    <article class="article-v2">
      <h1>{{ news.title }}</h1>
      <div class="article-meta">{{ news.date }}</div>
      <div class="article-body" v-html="news.content"></div>
    </article>
  </div>
</template>

<script>
import BreadcrumbV2 from '@/components/BreadcrumbV2.vue'
import { getNewsDetail } from '@/api/portal'

export default {
  name: 'NewsDetailV2',
  components: { BreadcrumbV2 },
  data() {
    return {
      news: {
        title: '公司启动"共读一本书"活动 深化学习型组织建设',
        date: '2026-03-18',
        content: '<p style="text-indent:2em;line-height:2;color:#475569;font-size:17px;">为进一步深化学习型组织建设，营造浓厚的学习氛围，公司近日正式启动"共读一本书"活动。本次活动旨在通过集体阅读、分享交流的方式，提升员工综合素质，增强团队凝聚力。</p><p style="text-indent:2em;line-height:2;color:#475569;font-size:17px;">活动第一阶段选读了《高效能人士的七个习惯》一书，各部门将组成读书小组，定期开展读书分享会。公司领导表示，将持续推进此类文化活动，将其作为企业文化建设的重要组成部分。</p>'
      }
    }
  },
  computed: {
    breadcrumbItems() {
      return [
        { nameKey: 'common.news', path: '/news' }
      ]
    }
  },
  created() {
    this.loadNews()
  },
  watch: {
    '$route.params.id': 'loadNews'
  },
  methods: {
    loadNews() {
      const id = this.$route.params.id
      if (!id) {
        return
      }
      getNewsDetail(id).then(data => {
        if (!data || !data.newsId) {
          return
        }
        this.news = {
          title: data.newsTitle,
          date: data.publishTime || '',
          content: data.newsContent || data.summary || ''
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.article-v2 {
  max-width: 800px;
  margin: 0 auto;

  h1 {
    font-size: 32px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 16px;
    line-height: 1.4;
  }

  .article-meta {
    font-size: 14px;
    color: #94a3b8;
    margin-bottom: 40px;
    padding-bottom: 24px;
    border-bottom: 1px solid #e2e8f0;
  }

  .article-body {
    p {
      margin-bottom: 20px;
    }
  }
}
</style>
